"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AttributeData_array, _AttributeData_byteOffset, _AttributeData_byteStride, _AttributeData_count, _AttributeData_elementBytes, _AttributeData_itemBytes, _AttributeData_itemSize, _AttributeData_max, _AttributeData_min, _AttributeData_morphAttributeData, _AttributeData_normalized, _AttributeData_sparse, _AttributeData_sparseIndices, _AttributeData_sparseValues, _AttributeData_target, _GeometryData_mode, _GeometryData_primitive, _GeometryData_attributeMaterial, _GeometryData_boundingBox, _GeometryData_effectMaterials, _GeometryData_material, _GeometryData_materialVariants, _GeometryData_morphWeights, _GeometryData_renderOrder, _GeometryData_standardMaterial, _PrimitiveData_attributes, _PrimitiveData_boundingBoxes, _PrimitiveData_indices;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimitiveData = exports.GeometryData = exports.AttributeData = void 0;
const viewer_shared_math_1 = require("@shapediver/viewer.shared.math");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const gl_matrix_1 = require("gl-matrix");
const IGeometryData_1 = require("../../interfaces/data/IGeometryData");
// #region Classes (3)
class AttributeData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (15)
    // #region Constructors (1)
    /**
     * Creates an attribute data object.
     *
     * @param _array the array of the data
     * @param _itemSize the size
     * @param _hasOffset notifier if there is an offset
     * @param _offset the offset
     * @param _stride the stride
     * @param _normalized boolean if the data is normalized
     */
    constructor(array, itemSize, itemBytes, byteOffset, elementBytes, normalized, count, min = [], max = [], byteStride, target, sparse, sparseIndices, sparseValues, morphAttributeData = [], id, version) {
        super(id, version);
        // #region Properties (15)
        _AttributeData_array.set(this, void 0);
        _AttributeData_byteOffset.set(this, void 0);
        _AttributeData_byteStride.set(this, void 0);
        _AttributeData_count.set(this, void 0);
        _AttributeData_elementBytes.set(this, void 0);
        _AttributeData_itemBytes.set(this, void 0);
        _AttributeData_itemSize.set(this, void 0);
        _AttributeData_max.set(this, []);
        _AttributeData_min.set(this, []);
        _AttributeData_morphAttributeData.set(this, []);
        _AttributeData_normalized.set(this, void 0);
        _AttributeData_sparse.set(this, void 0);
        _AttributeData_sparseIndices.set(this, void 0);
        _AttributeData_sparseValues.set(this, void 0);
        _AttributeData_target.set(this, void 0);
        __classPrivateFieldSet(this, _AttributeData_array, array, "f");
        __classPrivateFieldSet(this, _AttributeData_itemSize, itemSize, "f");
        __classPrivateFieldSet(this, _AttributeData_itemBytes, itemBytes, "f");
        __classPrivateFieldSet(this, _AttributeData_byteOffset, byteOffset, "f");
        __classPrivateFieldSet(this, _AttributeData_elementBytes, elementBytes, "f");
        __classPrivateFieldSet(this, _AttributeData_normalized, normalized, "f");
        __classPrivateFieldSet(this, _AttributeData_count, count, "f");
        __classPrivateFieldSet(this, _AttributeData_min, min, "f");
        __classPrivateFieldSet(this, _AttributeData_max, max, "f");
        __classPrivateFieldSet(this, _AttributeData_byteStride, byteStride, "f");
        __classPrivateFieldSet(this, _AttributeData_target, target, "f");
        __classPrivateFieldSet(this, _AttributeData_sparse, sparse, "f");
        __classPrivateFieldSet(this, _AttributeData_sparseIndices, sparseIndices, "f");
        __classPrivateFieldSet(this, _AttributeData_sparseValues, sparseValues, "f");
        __classPrivateFieldSet(this, _AttributeData_morphAttributeData, morphAttributeData, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (15)
    get array() {
        return __classPrivateFieldGet(this, _AttributeData_array, "f");
    }
    get byteOffset() {
        return __classPrivateFieldGet(this, _AttributeData_byteOffset, "f");
    }
    get byteStride() {
        return __classPrivateFieldGet(this, _AttributeData_byteStride, "f");
    }
    get count() {
        return __classPrivateFieldGet(this, _AttributeData_count, "f");
    }
    get elementBytes() {
        return __classPrivateFieldGet(this, _AttributeData_elementBytes, "f");
    }
    get itemBytes() {
        return __classPrivateFieldGet(this, _AttributeData_itemBytes, "f");
    }
    get itemSize() {
        return __classPrivateFieldGet(this, _AttributeData_itemSize, "f");
    }
    get max() {
        return __classPrivateFieldGet(this, _AttributeData_max, "f");
    }
    get min() {
        return __classPrivateFieldGet(this, _AttributeData_min, "f");
    }
    get morphAttributeData() {
        return __classPrivateFieldGet(this, _AttributeData_morphAttributeData, "f");
    }
    get normalized() {
        return __classPrivateFieldGet(this, _AttributeData_normalized, "f");
    }
    get sparse() {
        return __classPrivateFieldGet(this, _AttributeData_sparse, "f");
    }
    get sparseIndices() {
        return __classPrivateFieldGet(this, _AttributeData_sparseIndices, "f");
    }
    get sparseValues() {
        return __classPrivateFieldGet(this, _AttributeData_sparseValues, "f");
    }
    get target() {
        return __classPrivateFieldGet(this, _AttributeData_target, "f");
    }
    // #endregion Public Getters And Setters (15)
    // #region Public Methods (1)
    /**
     * Clones the attribute data.
     */
    clone() {
        return new AttributeData(__classPrivateFieldGet(this, _AttributeData_array, "f"), __classPrivateFieldGet(this, _AttributeData_itemSize, "f"), __classPrivateFieldGet(this, _AttributeData_itemBytes, "f"), __classPrivateFieldGet(this, _AttributeData_byteOffset, "f"), __classPrivateFieldGet(this, _AttributeData_elementBytes, "f"), __classPrivateFieldGet(this, _AttributeData_normalized, "f"), __classPrivateFieldGet(this, _AttributeData_count, "f"), __classPrivateFieldGet(this, _AttributeData_min, "f"), __classPrivateFieldGet(this, _AttributeData_max, "f"), __classPrivateFieldGet(this, _AttributeData_byteStride, "f"), __classPrivateFieldGet(this, _AttributeData_target, "f"), __classPrivateFieldGet(this, _AttributeData_sparse, "f"), __classPrivateFieldGet(this, _AttributeData_sparseIndices, "f"), __classPrivateFieldGet(this, _AttributeData_sparseValues, "f"), __classPrivateFieldGet(this, _AttributeData_morphAttributeData, "f"), this.id, this.version);
    }
}
exports.AttributeData = AttributeData;
_AttributeData_array = new WeakMap(), _AttributeData_byteOffset = new WeakMap(), _AttributeData_byteStride = new WeakMap(), _AttributeData_count = new WeakMap(), _AttributeData_elementBytes = new WeakMap(), _AttributeData_itemBytes = new WeakMap(), _AttributeData_itemSize = new WeakMap(), _AttributeData_max = new WeakMap(), _AttributeData_min = new WeakMap(), _AttributeData_morphAttributeData = new WeakMap(), _AttributeData_normalized = new WeakMap(), _AttributeData_sparse = new WeakMap(), _AttributeData_sparseIndices = new WeakMap(), _AttributeData_sparseValues = new WeakMap(), _AttributeData_target = new WeakMap();
class GeometryData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (10)
    // #region Constructors (1)
    /**
     * Creates a geometry data object.
     *
     * @param _primitive the primitive
     * @param id the id
     */
    constructor(primitive, mode = IGeometryData_1.PRIMITIVE_MODE.TRIANGLES, material = null, morphWeights = [], attributeMaterial = null, id, version) {
        super(id, version);
        // #region Properties (10)
        _GeometryData_mode.set(this, IGeometryData_1.PRIMITIVE_MODE.TRIANGLES);
        _GeometryData_primitive.set(this, void 0);
        _GeometryData_attributeMaterial.set(this, null);
        _GeometryData_boundingBox.set(this, new viewer_shared_math_1.Box());
        _GeometryData_effectMaterials.set(this, []);
        _GeometryData_material.set(this, null);
        _GeometryData_materialVariants.set(this, []);
        _GeometryData_morphWeights.set(this, []);
        _GeometryData_renderOrder.set(this, 0);
        _GeometryData_standardMaterial.set(this, null);
        __classPrivateFieldSet(this, _GeometryData_primitive, primitive, "f");
        __classPrivateFieldSet(this, _GeometryData_boundingBox, this.primitive.boundingBox.clone(), "f");
        __classPrivateFieldSet(this, _GeometryData_morphWeights, morphWeights, "f");
        __classPrivateFieldSet(this, _GeometryData_mode, mode, "f");
        __classPrivateFieldSet(this, _GeometryData_material, material, "f");
        __classPrivateFieldSet(this, _GeometryData_standardMaterial, material, "f");
        __classPrivateFieldSet(this, _GeometryData_attributeMaterial, attributeMaterial, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (15)
    get attributeMaterial() {
        return __classPrivateFieldGet(this, _GeometryData_attributeMaterial, "f");
    }
    set attributeMaterial(value) {
        __classPrivateFieldSet(this, _GeometryData_attributeMaterial, value, "f");
    }
    get boundingBox() {
        return __classPrivateFieldGet(this, _GeometryData_boundingBox, "f");
    }
    get effectMaterials() {
        return __classPrivateFieldGet(this, _GeometryData_effectMaterials, "f");
    }
    get material() {
        return __classPrivateFieldGet(this, _GeometryData_material, "f");
    }
    set material(value) {
        __classPrivateFieldSet(this, _GeometryData_material, value, "f");
    }
    get materialVariants() {
        return __classPrivateFieldGet(this, _GeometryData_materialVariants, "f");
    }
    get mode() {
        return __classPrivateFieldGet(this, _GeometryData_mode, "f");
    }
    get morphWeights() {
        return __classPrivateFieldGet(this, _GeometryData_morphWeights, "f");
    }
    set morphWeights(value) {
        __classPrivateFieldSet(this, _GeometryData_morphWeights, value, "f");
    }
    get primitive() {
        return __classPrivateFieldGet(this, _GeometryData_primitive, "f");
    }
    get renderOrder() {
        return __classPrivateFieldGet(this, _GeometryData_renderOrder, "f");
    }
    set renderOrder(value) {
        __classPrivateFieldSet(this, _GeometryData_renderOrder, value, "f");
    }
    get standardMaterial() {
        return __classPrivateFieldGet(this, _GeometryData_standardMaterial, "f");
    }
    set standardMaterial(value) {
        __classPrivateFieldSet(this, _GeometryData_standardMaterial, value, "f");
    }
    // #endregion Public Getters And Setters (15)
    // #region Public Methods (2)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new GeometryData(__classPrivateFieldGet(this, _GeometryData_primitive, "f"), __classPrivateFieldGet(this, _GeometryData_mode, "f"), __classPrivateFieldGet(this, _GeometryData_material, "f"), __classPrivateFieldGet(this, _GeometryData_morphWeights, "f"), __classPrivateFieldGet(this, _GeometryData_attributeMaterial, "f"));
    }
    intersect(origin, direction) {
        if (this.mode !== IGeometryData_1.PRIMITIVE_MODE.TRIANGLES)
            return null;
        return this.boundingBox.intersect(origin, direction);
    }
}
exports.GeometryData = GeometryData;
_GeometryData_mode = new WeakMap(), _GeometryData_primitive = new WeakMap(), _GeometryData_attributeMaterial = new WeakMap(), _GeometryData_boundingBox = new WeakMap(), _GeometryData_effectMaterials = new WeakMap(), _GeometryData_material = new WeakMap(), _GeometryData_materialVariants = new WeakMap(), _GeometryData_morphWeights = new WeakMap(), _GeometryData_renderOrder = new WeakMap(), _GeometryData_standardMaterial = new WeakMap();
class PrimitiveData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (3)
    // #region Constructors (1)
    /**
     * Creates a primitive data object.
     *
     * @param _attributes the attributes as key-value pairs
     * @param _indices the indices
     */
    constructor(attributes = {}, indices = null, id, version) {
        super(id, version);
        // #region Properties (3)
        _PrimitiveData_attributes.set(this, {});
        _PrimitiveData_boundingBoxes.set(this, []);
        _PrimitiveData_indices.set(this, null);
        __classPrivateFieldSet(this, _PrimitiveData_attributes, attributes, "f");
        __classPrivateFieldSet(this, _PrimitiveData_indices, indices, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get attributes() {
        return __classPrivateFieldGet(this, _PrimitiveData_attributes, "f");
    }
    get boundingBox() {
        return this.computeBoundingBox(gl_matrix_1.mat4.create());
    }
    get indices() {
        return __classPrivateFieldGet(this, _PrimitiveData_indices, "f");
    }
    set indices(value) {
        __classPrivateFieldSet(this, _PrimitiveData_indices, value, "f");
    }
    // #endregion Public Getters And Setters (4)
    // #region Public Methods (2)
    /**
     * Clones the primitive data.
     */
    clone() {
        const attributes = {};
        for (const attribute in __classPrivateFieldGet(this, _PrimitiveData_attributes, "f"))
            attributes[attribute] = (__classPrivateFieldGet(this, _PrimitiveData_attributes, "f")[attribute].clone());
        return new PrimitiveData(attributes, __classPrivateFieldGet(this, _PrimitiveData_indices, "f"), this.id, this.version);
    }
    computeBoundingBox(matrix) {
        const res = __classPrivateFieldGet(this, _PrimitiveData_boundingBoxes, "f").find((b) => gl_matrix_1.mat4.equals(matrix, b.matrix));
        if (res)
            return res.boundingBox;
        if (__classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"]) {
            if (__classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].min.length === 3 &&
                __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].max.length === 3 &&
                gl_matrix_1.mat4.equals(matrix, gl_matrix_1.mat4.create())) {
                const boundingBox = new viewer_shared_math_1.Box(gl_matrix_1.vec3.fromValues(__classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].min[0], __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].min[1], __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].min[2]), gl_matrix_1.vec3.fromValues(__classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].max[0], __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].max[1], __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].max[2]));
                __classPrivateFieldGet(this, _PrimitiveData_boundingBoxes, "f").push({
                    boundingBox,
                    matrix: gl_matrix_1.mat4.clone(matrix),
                });
                return boundingBox;
            }
            else if (gl_matrix_1.mat4.equals(matrix, gl_matrix_1.mat4.create())) {
                const boundingBox = new viewer_shared_math_1.Box();
                boundingBox.setFromAttributeArray(__classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].array, __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].byteStride, __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].itemBytes);
                __classPrivateFieldGet(this, _PrimitiveData_boundingBoxes, "f").push({
                    boundingBox,
                    matrix: gl_matrix_1.mat4.clone(matrix),
                });
                return boundingBox;
            }
            else if (gl_matrix_1.quat.equals(gl_matrix_1.mat4.getRotation(gl_matrix_1.quat.create(), matrix), gl_matrix_1.quat.create())) {
                const identityBB = this.computeBoundingBox(gl_matrix_1.mat4.create());
                const boundingBox = identityBB.clone().applyMatrix(matrix);
                __classPrivateFieldGet(this, _PrimitiveData_boundingBoxes, "f").push({
                    boundingBox,
                    matrix: gl_matrix_1.mat4.clone(matrix),
                });
                return boundingBox;
            }
            else {
                const boundingBox = new viewer_shared_math_1.Box();
                boundingBox.setFromAttributeArray(__classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].array, __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].byteStride, __classPrivateFieldGet(this, _PrimitiveData_attributes, "f")["POSITION"].itemBytes, matrix);
                __classPrivateFieldGet(this, _PrimitiveData_boundingBoxes, "f").push({
                    boundingBox,
                    matrix: gl_matrix_1.mat4.clone(matrix),
                });
                return boundingBox;
            }
        }
        return new viewer_shared_math_1.Box();
    }
}
exports.PrimitiveData = PrimitiveData;
_PrimitiveData_attributes = new WeakMap(), _PrimitiveData_boundingBoxes = new WeakMap(), _PrimitiveData_indices = new WeakMap();
// #endregion Classes (3)
//# sourceMappingURL=GeometryData.js.map